import React, { useState, useEffect, useRef } from "react";
import { getColor, getLogo, getBgGradient } from "./utils";
import { iconNameSwaps } from "../utils";

export function NewCategoryIcon(props) {
  let { iconFullName, iconColor, iconName, iconPath, selected, onClickHandler, widthOffset } = props;

  let [highlight, setHighlight] = useState(false);

  // The body of the logic
  let styleObj = {};
  let cardStyle = { paddingBottom: "1em" };

  let outline = highlight ? "3px solid white" : null;
  outline = selected ? "3px solid black" : outline;

  // Transfer names to a standard name (ie  EMS to Environmental Management)
  let renderName = iconNameSwaps[iconFullName] || iconFullName;

  let logoSrc = getLogo(iconName, iconPath);
  console.log("Rendering logo", name, logoSrc);

  return (
    <div
      onClick={onClickHandler}
      onMouseEnter={(e) => setHighlight(true)}
      onMouseLeave={(e) => setHighlight(false)}
      style={{
        display: "flex",
        alignItems: "stretch",
      }}
    >
      <div
        className="card p-0 mb-2 mr-1 shadow"
        style={{
          backgroundColor: getColor(iconColor),
          backgroundImage: getBgGradient(iconColor),
          backgroundImage: getBgGradient(iconColor),
          outline: outline,
          outlineOffset: "-2px",
          boxShadow: "0 10px 16px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19)",
          borderRadius: "1rem",
          cursor: selected ? "grab" : "pointer",
          opacity: 1,
          flex: 1,
        }}
      >
        <div className="card-body">
          <h6 className="card-title text-white">
            <img
              className="mr-2"
              src={logoSrc}
              height="30px"
              style={{
                verticalAlign: "middle",
                minHeight: "30px",
                minWidth: "30px",
              }}
              alt=""
            />
            <span style={{ verticalAlign: "middle" }}>{renderName}</span>
          </h6>{" "}
        </div>
      </div>
    </div>
  );
}

function CategoryIcon(props) {
  let {
    iconHeightHandler,
    iconHeight,
    iconFullName,
    iconColor,
    iconName,
    iconPath,
    selected,
    onClickHandler,
    widthOffset,
  } = props;

  // Some refs, state and effects
  const heightEl = useRef(null);
  let [highlight, setHighlight] = useState(false);
  useEffect(() => {
    if (iconHeightHandler) {
      iconHeightHandler(heightEl);
    }
  });

  // The body of the logic
  let styleObj = iconHeight ? { minHeight: `${iconHeight}px` } : {};
  let cardStyle = { paddingBottom: "1em" };

  let outline = highlight ? "3px solid white" : null;
  outline = selected ? "3px solid black" : outline;

  // Transfer names to a standard name (ie  EMS to Environmental Management)
  let renderName = iconNameSwaps[iconFullName] || iconFullName;

  return (
    <div
      className={`${widthOffset}`}
      style={cardStyle}
      onClick={onClickHandler}
      onMouseEnter={(e) => setHighlight(true)}
      onMouseLeave={(e) => setHighlight(false)}
    >
      <div
        className={`card h-100 m-0 p-0`}
        style={{
          backgroundColor: getColor(iconColor),
          backgroundImage: getBgGradient(iconColor),
          outline: outline,
          outlineOffset: "-2px",
          boxShadow: selected
            ? "0 10px 16px 0 rgba(0,0,0,0.9),0 6px 20px 0 rgba(0,0,0,0.1)"
            : "0 10px 16px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19)",
          borderRadius: "30px",
          cursor: selected ? "grab" : "pointer",
        }}
      >
        <div className="card-img">
          <img
            className="card-img-top-fluid mx-auto d-block"
            src={getLogo(iconName, iconPath)}
            width="80px"
            style={{ marginTop: "1em" }}
            alt=""
          />
        </div>

        <div className="card-body" style={{ color: "white" }}>
          <h6 className="card-title text-center" ref={heightEl} style={styleObj}>
            {renderName}
          </h6>
        </div>
      </div>
    </div>
  );
}

export default CategoryIcon;
